export default {
      id: "icon-gallery-usage",
      viewBox: "0 0 100 83",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-gallery",
      toString: function () {
        return this.url;
      }
    }